var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.104,
    height: 14.201,
    viewBox: "0 0 15.104 14.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(0 -15.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "M4.44,15.3v3.564H15.1V15.3ZM14.2,17.961H5.319V16.179H14.2v1.782ZM4.44,24.182H15.1V20.619H4.44Zm.879-2.661H14.2V23.3H5.319ZM4.44,29.5H15.1V25.964H4.44Zm.879-2.661H14.2v1.782H5.319ZM0,18.864H3.564V15.3H0Zm.879-2.684H2.661v1.782H.879Zm-.879,8H3.564V20.619H0Zm.879-2.661H2.661V23.3H.879ZM0,29.5H3.564V25.964H0ZM.879,26.84H2.661v1.782H.879Z",
    transform: "translate(0 0)",
    fill: "#97aabc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.8facff3f7a4ec50f55d1f441ac755486.svg";
export { ForwardRef as ReactComponent };